import React from 'react';
import { useTranslation } from 'react-i18next';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
const DisabledVariant = ({ className , size ='medium'  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(SolidButton, {
        className: className,
        size: size,
        variant: "main",
        priority: "primary",
        disabled: true
    }, t('deviation.tier.noSubscribing'));
};
DisabledVariant.displayName = 'DisabledVariant';
export default DisabledVariant;
